<nz-breadcrumb>
	<nz-breadcrumb-item>
		<a [routerLink]="['/home']">Home</a>
	</nz-breadcrumb-item>
	<nz-breadcrumb-item>
		<a [routerLink]="['/subscriber/document-search']">Document Search</a>
	</nz-breadcrumb-item>
	<nz-breadcrumb-item *ngIf="!data">View Document</nz-breadcrumb-item>
	<nz-breadcrumb-item *ngIf="data">View: {{data.document.documentType}} ({{data.document.documentNumber}}) </nz-breadcrumb-item>
</nz-breadcrumb>

<div class="row mt-2" *ngIf="data">
	<div class="col">
		<div class="card">
			<div class="card-header text-bg-success">
				<span class="h4">{{getGivenNames()}} {{data.document.lastName}}</span>
				<a class="float-end btn btn-sm btn-outline-light" (click)="goBack()"> Go Back</a>
			</div>
		    <nz-tabset [nzTabPosition]="'top'" nzType="card" nzSize="small"  [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="selectedTabIndex = $event">
				<nz-tab [nzTitle]="'Overview'" class="m-0">
					<div class="card-body bg-secondary-subtle">
						<div class="row mb-3">
							<div class="col">
								<span class="h2">Document Details</span>
								<a class="float-end btn btn-sm btn-light" [routerLink]="['/subscriber','view','document',data.document.id,data.person.id]">
									View Subscriber
								</a>
							</div>
						</div>
						<div class="row g-2">
							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingIdType" [value]="data.document.documentType" [readOnly]="true" >
										<label for="floatingIdType">ID Type</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingIdNumber" [value]="data.document.idNumber" [readOnly]="true" >
										<label for="floatingIdNumber">ID Number</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingInput" [value]="data.document.documentNumber" [readOnly]="true" >
										<label for="floatingInput">Document Number</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingDateOfIssue" [value]="data.document.dateOfIssue" [readOnly]="true" >
										<label for="floatingDateOfIssue">Date of Issue</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingDateOfExpiry" [value]="data.document.dateOfExpiry" [readOnly]="true" >
										<label for="floatingDateOfExpiry">Date of Expiry</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingIssuingCountry" [value]="data.document.issuingCountry" [readOnly]="true" >
										<label for="floatingIssuingCountry">Issuing Country</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingGivenNames" [value]="getGivenNames()" [readOnly]="true" >
										<label for="floatingGivenNames">Given Names</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingSurname" [value]="data.document.lastName" [readOnly]="true" >
										<label for="floatingSurname">Surname</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingDateOfBirth" [value]="data.document.dateOfBirth" [readOnly]="true" >
										<label for="floatingDateOfBirth">Date of Birth</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingDateOfBirth" [value]="data.document.nationality" [readOnly]="true" >
										<label for="floatingDateOfBirth">Nationality</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingCounty" [value]="data.document.county" [readOnly]="true" >
										<label for="floatingCounty">County</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingSubCounty" [value]="data.document.subCounty" [readOnly]="true" >
										<label for="floatingSubCounty">Sub County</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingDivision" [value]="data.document.division" [readOnly]="true" >
										<label for="floatingDivision">Division</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingLocation" [value]="data.document.location" [readOnly]="true" >
										<label for="floatingLocation">Location</label>
									</div>
								</div>
							</div>

							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingSubLocation" [value]="data.document.subLocation" [readOnly]="true" >
										<label for="floatingSubLocation">Sub Location</label>
									</div>
								</div>
							</div>
							<div class="col-3">
								<div class="card">
									<div class="form-floating">
										<input type="text" class="form-control border border-0" id="floatingSubLocation" [value]="data.document.verificationStatus" [readOnly]="true" >
										<label for="floatingSubLocation">Verification Status</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card-body bg-secondary-subtle">
						<h2>Minors</h2>
						<p *ngIf="data.minors.length == 0">No minors registered</p>
						<div class="row mt-1" *ngIf="data.minors.length > 0">
							<div class="col">
								<table class="table">
									<thead class="table-success">
										<tr>
											<th>Registered Date</th>
											<th>Given Names</th>
											<th>Last Name</th>
											<th>Gender</th>
											<th>Date Of Birth</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let minor of data.minors">
											<td>{{minor.createdAt | date}}</td>
											<td>{{getMinorGivenNames(minor)}}</td>
											<td>{{minor.lastName}}</td>
											<td>{{minor.gender}}</td>
											<td>{{minor.dateOfBirth| date}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div class="card-body bg-secondary-subtle">
						<h2>Sim Cards</h2>
						<div class="row mt-1">
							<div class="col">
								<table class="table">
									<thead class="table-success">
										<tr>
											<th>ICCID</th>
											<th>Sim Serial</th>
											<th>MSISDN</th>
											<th>Status</th>
											<th>Registration Date</th>
											<th>End Date</th>
											<th>Partner</th>
											<th>For Minor</th>
											<th>Uploaded By</th>
											<th>Uploaded Time</th>
											<th>Verification</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let msisdn of data.msisdns">
											<td>{{msisdn.iccid}}</td>
											<td>{{msisdn.simSerial}}</td>
											<td>{{msisdn.internationalMsisdn}}</td>
											<td>
												<span *ngIf="msisdn.simStatus == 'Active'" class="text-success">Active</span>
												<span *ngIf="msisdn.simStatus == 'Swapped'" class="text-warning">Swapped</span>
												<span *ngIf="msisdn.simStatus == 'Transferred'" class="text-warning">Transferred</span>
												<span *ngIf="msisdn.simStatus == 'Terminated'" class="text-warning">Terminated</span>
											</td>
											<td>{{msisdn.startDate | date}}</td>
											<td>{{(msisdn.endDate | date)??'-'}}</td>
											<td>{{msisdn.partner.name}}</td>
											<td>{{findMinor(msisdn)?.firstName??'-'}}</td>
											<td>{{msisdn.uploadedBy?.username??'FTP'}}</td>
											<td>{{msisdn.uploadedAt | date }}</td>
											<td>
												<fa-icon [icon]="faCheck" *ngIf="msisdn.documentStatus == 'Perfect'" class="text-success"></fa-icon>
												<fa-icon [icon]="faCheck" *ngIf="msisdn.documentStatus == 'Match'" class="text-success"></fa-icon>
												<fa-icon [icon]="faCheck" *ngIf="msisdn.documentStatus == 'Acceptable'" class="text-success"></fa-icon>
												<fa-icon [icon]="faXmark" *ngIf="msisdn.documentStatus == 'Failed'" class="text-danger"></fa-icon>
												<fa-icon [icon]="faNotdef" *ngIf="msisdn.documentStatus == 'NotFound'" class="text-warning"></fa-icon>
												<fa-icon [icon]="faHourglass" *ngIf="msisdn.documentStatus == 'Skipped'" class="text-secondary"></fa-icon>
												<fa-icon [icon]="faHourglass" *ngIf="msisdn.documentStatus == 'Pending'" class="text-secondary"></fa-icon>
												{{msisdn.documentStatus}}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</nz-tab>
				<nz-tab nzTitle="Audit: View" *hasPermission="['AuditViewList']">
					<app-audit-table-views *ngIf="selectedTabIndex == 1" [fetchAudits]="fetchAudits"></app-audit-table-views>
				</nz-tab>
			</nz-tabset>
		</div>
	</div>
</div>
